type Mode = "center" | "limit" | "mixed";

type DmaSelectorProps = {
  mode: Mode;
  inside: number;
  outside: number;
  onChange: (value: { mode: Mode; inside: number; outside: number }) => void;
};

export default function DmaSelector({ mode, inside, outside, onChange }: DmaSelectorProps) {
  const isMixed = mode === "mixed";

  return (
    <div className="flex items-center gap-2 text-sm">
      <label className="text-slate-600">DMA:</label>
      <select
        className="border rounded-lg px-2 py-1"
        value={mode}
        onChange={(e) => onChange({ mode: e.target.value as Mode, inside, outside })}
      >
        <option value="center">Centro</option>
        <option value="limit">Limite</option>
        <option value="mixed">Misto</option>
      </select>

      <div className="flex items-center gap-1">
        <span className="text-xs text-slate-500">dentro×</span>
        <input
          type="number"
          step="0.1"
          min="0"
          max="5"
          className="w-16 border rounded-lg px-2 py-1 disabled:bg-slate-50"
          value={inside}
          disabled={!isMixed}
          onChange={(e) =>
            onChange({ mode, inside: Number(e.target.value), outside })
          }
          title="Peso dentro da faixa ideal"
        />
      </div>

      <div className="flex items-center gap-1">
        <span className="text-xs text-slate-500">fora×</span>
        <input
          type="number"
          step="0.1"
          min="0"
          max="5"
          className="w-16 border rounded-lg px-2 py-1 disabled:bg-slate-50"
          value={outside}
          disabled={!isMixed}
          onChange={(e) =>
            onChange({ mode, inside, outside: Number(e.target.value) })
          }
          title="Peso fora da faixa ideal"
        />
      </div>
    </div>
  );
}
